import { TechTableInfoModel } from './../../core/models/tech-table-info.model';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfig } from '@tech-utils/app-config.service';
import { LaboratoryService, StatusResultInterface } from '@techrules/portallib';

@Component({
  selector: 'tech-tech-table-info-modal',
  templateUrl: './tech-table-info-modal.component.html',
  styleUrls: ['./tech-table-info-modal.component.scss'],
})
export class TechTableInfoModalComponent implements OnInit {
  data: TechTableInfoModel;
  urlTReport: string = undefined;
  public favoritesonPortal: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dataDialog: TechTableInfoModel,
    private dialogRef: MatDialogRef<TechTableInfoModalComponent>,
    private readonly laboratoryService: LaboratoryService
  ) {
    if (dataDialog != undefined) {
      this.data = dataDialog;
      if (dataDialog.url != undefined) {
        // Show TReport tab
        this.urlTReport = dataDialog.url;
      }
    }
  }
  ngOnInit(): void {
    this.favoritesonPortal = AppConfig.settings.favoritesOnClientPortal;
  }

  onClose() {
    document
      .getElementsByClassName('tranimate__animated')[0]
      .classList.remove('tranimate__slideInRight');
    document
      .getElementsByClassName('tranimate__animated')[0]
      .classList.add('tranimate__slideOutRight');
    setTimeout(() => {
      this.dialogRef.close(false);
    }, 1000);
  }

  changeFavourite(event: Event) {
    // this.disableFav = true;

    event.stopPropagation();

    if (this.data.isFavourite) {
      this.laboratoryService
        .deleteFavourite(this.data.code)
        .subscribe((res: StatusResultInterface) => {
          if (res.status) {
            this.data.isFavourite = !this.data.isFavourite;
          }
          //  this.disableFav = false;
        });
    } else {
      this.laboratoryService
        .addFavourite(this.data.code)
        .subscribe((res: StatusResultInterface) => {
          if (res.status) {
            this.data.isFavourite = !this.data.isFavourite;
          }
          //  this.disableFav = false;
        });
    }
  }
}
